import DataHelpers from './DataHelpers'
import FirebaseHelpers from './FirebaseHelpers'
import Store from '../store/Store'

export default class CodeHelpers {
    
    static run_copy_element_attribute() {
        console.log('copying attribute...')
    }


}


// WEBPACK FOOTER //
// ./src/helpers/CodeHelpers.js